import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "../../styles";

export const toggleButtonGroup = style({
  display: "flex",
  justifyContent: "space-evenly",
  borderRadius: vars.radii.s,
  backgroundColor: vars.colors.primaryContainer,
  padding: vars.space["2xs"],
});

export const toggleWrapper = style({
  width: "100%",
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      width: 343,
    },
  },
});
